import { Transform, Type } from "class-transformer";
import {
  IsIn,
  IsInt,
  IsOptional,
  IsString,
  IsIP,
  ValidateIf,
  Min,
  Max,
  IsNotEmpty,
  ValidateNested
} from "class-validator";
import { IsValidDnsContent } from "../validators/dns-content-validator";

export class SRVRecordDto {
  @Transform(({ value }) => parseInt(value))
  @IsInt()
  @Min(0)
  priority: number;

  @Transform(({ value }) => parseInt(value))

  @IsInt()
  @Min(0)
  weight: number;

  @Transform(({ value }) => parseInt(value))
  @IsInt()
  @Min(1)
  @Max(65535)
  port: number;

  @Transform(({ value }) => (typeof value === 'string' ? value.trim() : value))
  @IsNotEmpty({ message: 'validation.target_must_be_a_valid_string_hostname_text' })
  target: string;
}

export class DnsRecordDto {

  @IsIn(["A", "AAAA", "CNAME", "MX", "NS", "SRV", "TXT"])
  type: string;

  @Transform(({ value }) => (typeof value === 'string' ? value.trim() : value))
  @IsNotEmpty({ message: 'validation.name_must_be_a_valid_string' })
  name: string;

  @ValidateIf(o => o.type === "MX")
  @Transform(({ value }) => parseInt(value))
  @IsInt()
  @Min(0)
  priority: number;

  @ValidateIf(o => o.type === 'SRV')
  @ValidateNested()
  @Type(() => SRVRecordDto)
  data: SRVRecordDto = {
    priority: null,
    weight: null,
    port: null,
    target: '',
  };


  @Transform(({ value }) => parseInt(value))
  @IsInt()
  @Min(1)
  ttl: number;

  @IsValidDnsContent({ message: "validation.invalid_content_for_dns_record_type" })
  content: string;
}
